import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getFertilizer.try: {
            return true;
        }

        case constants.getFertilizer.success:
        case constants.getFertilizer.error: {
            return false;
        }

        default:
            return state;
    }
}